import { createContext, useMemo, useEffect } from 'react';
import { createIconCache } from '../utils/iconCache.js';
import { DefaultPortalRefProvider } from './DefaultPortalRefProvider/DefaultPortalRefProvider.js';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';

const GigerConfigContext = /*#__PURE__*/createContext({
  resolveIcon: () => Promise.resolve(''),
  iconCache: createIconCache(),
  emotionCacheShadowRootContainer: undefined
});
const GigerConfigProvider = _ref => {
  let {
    children,
    resolveIcon,
    iconCache: _iconCache,
    emotionCacheShadowRootContainer
  } = _ref;
  const iconCache = useMemo(() => {
    return _iconCache || createIconCache();
  }, [_iconCache]);
  useEffect(() => {
    iconCache.reset();
  }, [iconCache, resolveIcon]);
  return jsx(GigerConfigContext.Provider, {
    value: {
      resolveIcon,
      iconCache,
      emotionCacheShadowRootContainer
    },
    children: jsx(GigerDefaultPortalRefIfShadowRootContainer, {
      emotionCacheShadowRootContainer: emotionCacheShadowRootContainer,
      children: children
    })
  });
};
const GigerDefaultPortalRefIfShadowRootContainer = _ref2 => {
  let {
    children,
    emotionCacheShadowRootContainer
  } = _ref2;
  const portalRef = useMemo(() => ({
    current: emotionCacheShadowRootContainer
  }), [emotionCacheShadowRootContainer]);
  if (emotionCacheShadowRootContainer && portalRef.current !== undefined) {
    return jsx(DefaultPortalRefProvider, {
      portalRef: portalRef,
      children: children
    });
  } else {
    return jsx(Fragment, {
      children: children
    });
  }
};

export { GigerConfigContext, GigerConfigProvider, GigerDefaultPortalRefIfShadowRootContainer };
//# sourceMappingURL=GigerConfigProvider.js.map
